import { render, staticRenderFns } from "./OrgChildDepartment.vue?vue&type=template&id=a2456b7c&scoped=true"
import script from "./OrgChildDepartment.vue?vue&type=script&lang=js"
export * from "./OrgChildDepartment.vue?vue&type=script&lang=js"
import style0 from "./OrgChildDepartment.vue?vue&type=style&index=0&id=a2456b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2456b7c",
  null
  
)

export default component.exports